export const ORIGIN_FILTER_ADDED = 'originAdded'
export const DESTIN_FILTER_ADDED = 'destinAdded'
export const FNUM_FILTER_ADDED = 'fNumAdded'
export const FLIGHTS_ADDED = 'flightsAdded'
export const RESET_TRIGGERED = 'resetTriggered'
export const DESTINATION_OPTIONS_UPDATED = 'destinationOptionsUpdated';



// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/actionTypes.js